const src = import.meta.ROLLUP_FILE_URL_DzYsnjr1LtW1tBWqsYm2RQ;
export default {
  src,
  srcSet: src + " " + 4096 + "w",
  width: 4096,
  height: 2730,
};